module.exports = __webpack_public_path__ + "img/download-qr-code.91ed520f.png";